export enum LoginFlags {
    LOGIN_FROM_DASHBOARD = 'LOGIN_FROM_DASHBOARD',
    LOGIN_FROM_MTPL = 'LOGIN_FROM_MTPL',
    LOGIN_FROM_TRAVEL = 'LOGIN_FROM_TRAVEL',
    LOGIN_FROM_PROPERTY = 'LOGIN_FROM_PROPERTY'
}
